// For resource === categories, customizations, tiers, coupons
export const redirectToResourcePageWithRefresh = async (redirectArgs) => {
  const {
    apiToken,
    actions,
    resource,
  } = redirectArgs;
  redirectToResourcePage(redirectArgs);
  await actions.getAllResources(apiToken, resource);
};

// For resource === 'products', orders, locations, users
export const redirectToResourcePage = (redirectArgs) => {
  const {
    resource,
    history,
    locationStateParams,
  } = redirectArgs;
  if (resource === 'products') {
    history.push('/menu', locationStateParams);
  }
  history.push(`/${resource}`, locationStateParams);
};
